<template>
<base-popup-dialog v-model="value" :maxBodyWidth="500" :maxBodyHeight="400" title="User Communication Preferences">
    <div slot="dialogBody">
            <v-layout wrap >
					<v-container no-gutters style="text-align:left" class="ma-5 mb-5 pa-0 pb-5">						
						<v-row no-gutters>
							<div class="display-6 mb-2 pa-0 pb-2" >{{ userPreferencesHeader }}</div>
						</v-row>

                        <v-row no-gutters class="mb-0 pt-0 pb-0">
							<v-col class="ml-0 mr-0">
                                <v-checkbox color="teal" dense class="mt-0 mb-0 pt-0 pb-0" 
                                label='Urgent Communications' v-model="local_user_preferences_details.urgentCommunications" disabled></v-checkbox>
                            </v-col>                            
                        </v-row>
                        <v-row no-gutters >
							<v-col class="ml-0 mr-0">
                                <v-checkbox color="teal" dense class="mt-0 mb-0 pt-0 pb-0" 
                                label='Data Availability/Delays' v-model="local_user_preferences_details.dataAvailabilityDelays"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row no-gutters >
							<v-col class="ml-0 mr-0">
                                <v-checkbox color="teal" dense class="mt-0 mb-0 pt-0 pb-0" 
                                label='General Communications' v-model="local_user_preferences_details.generalCommunications"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row no-gutters >
							<v-col class="ml-0 mr-0">
                                <v-checkbox color="teal" dense class="mt-0 mb-0 pt-0 pb-0" 
                                label='New Releases/Announcements' v-model="local_user_preferences_details.newReleaseAnnouncements"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row no-gutters dense>
							<v-col class="ml-0 mr-0">
                                <v-checkbox color="teal" dense class="mt-0 mb-0 pt-0 pb-0" 
                                label='System Downtime' v-model="local_user_preferences_details.systemDowntime"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row no-gutters dense>
							<v-col class="ml-0 mr-0">
                                <v-checkbox color="teal" dense class="mt-0 mb-0 pt-0 pb-0" label='Data Quality' v-model="local_user_preferences_details.dataQuality"></v-checkbox>
                            </v-col>
                        </v-row>				
					</v-container>
				</v-layout>
        </div>
        <div slot="dialogFooter">
            <v-card-actions>
					<v-spacer></v-spacer>
                        <v-btn  text color="primary"  @click="submitPreferences" >Submit</v-btn>
                        <v-btn  text color="primary"  @click="onCloseDlg">Cancel</v-btn>
				</v-card-actions>
        </div>
</base-popup-dialog>
</template>

<script>
import userPreferences from '../data/user-preferences'
import BasePopUpDialog from "@/dialogs/base-popup-dialog.vue";

export default {
    props: ["value", "user_preferences_details"],

    components: {
        "base-popup-dialog": BasePopUpDialog
    },
    data(){
        return {
            userPreferencesHeader: userPreferences.header,
            local_user_preferences_details:{
                urgentCommunications: this.user_preferences_details.urgentCommunications,
                dataAvailabilityDelays: this.user_preferences_details.dataAvailabilityDelays,
                generalCommunications: this.user_preferences_details.generalCommunications,
                newReleaseAnnouncements: this.user_preferences_details.newReleaseAnnouncements,
                systemDowntime: this.user_preferences_details.systemDowntime,
                dataQuality: this.user_preferences_details.dataQuality
            },
            showcaseAction_dlg: false,
            showcaseActionMessage: null,
            actionFlag: false
        }
    },

    methods: {
        onCloseDlg(){
            this.$emit("input", false);
            this.$emit("closeSettingDialog");
        },
        closeShowcaseActionDailogBox(actionFlag){
            if(actionFlag){
                this.showcaseAction_dlg = false;
                this.onCloseDlg();
            }else{
                this.showcaseAction_dlg = false;
            }
        },

        async submitPreferences(){
            console.log("inside submitPreferences() method");
            const formData = new FormData();
            formData.append("userId", this.$store.getters.getUserId);
            formData.append("urgentCommunications", this.local_user_preferences_details.urgentCommunications);
            formData.append("dataAvailabilityDelays", this.local_user_preferences_details.dataAvailabilityDelays);
            formData.append("generalCommunications", this.local_user_preferences_details.generalCommunications);
            formData.append("newReleaseAnnouncements", this.local_user_preferences_details.newReleaseAnnouncements);
            formData.append("systemDowntime", this.local_user_preferences_details.systemDowntime);
            formData.append("dataQuality", this.local_user_preferences_details.dataQuality);
            console.log("formData: "+formData);
            const response = await this.$store.dispatch("addUserPreferences", {entity:formData, callbackFunc:()=>{
                    this.$emit("input", false);
                    this.$emit("closeSettingDialog");
				}});             
            console.log(response);           
        }
    }
    
}
</script>